import React from 'react';

type Props = {
  className?: string;
};

function FiltersDogsIcon({ className }: Props) {
  return (
    <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>filter-dog-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -60) translate(70 60)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path d="M31.77 14a1.73 1.73 0 0 0-1.39-.71 1.69 1.69 0 0 1-1.26-.48 2.37 2.37 0 0 0-1.82-1.11H26a2.09 2.09 0 0 0-2 1.18l-1.71 3.66L16 8.48a.76.76 0 0 0-1-.13.75.75 0 0 0-.13 1.06l6.03 7.78h-5.06c-4.35 0-4.95.93-7.49 4.85l.61.44.65.37a19.082 19.082 0 0 1 2.3-3.16c-.05 2.46-.27 2.84-1 3.76-.91 1.21-1.43 1.72-1.47 1.77a2.61 2.61 0 0 0-.6 1.67v4.05a.74.74 0 0 0 .75.75h3.61a.74.74 0 0 0 .57-1.23l-.87-1v-.55a3.24 3.24 0 0 1 .7-2l.07-.07 2.21 4.5a.75.75 0 0 0 .68.42h3.06a.72.72 0 0 0 .66-.4.76.76 0 0 0 0-.78l-.83-1.17-1-1.78a1.24 1.24 0 0 1 0-1l1.74-1.82 1.23.55v.11L22.58 27c.177.256.271.56.27.87v3.08a.75.75 0 0 0 .75.75H27a.74.74 0 0 0 .67-.41.76.76 0 0 0-.06-.78l-.43-.58c-.17-.25-.2-.33-.2-.49v-9.07l1.16-2.64h1a2.45 2.45 0 0 0 2.31-1.29l.13-.32c.09-.21.19-.43.4-1a1.24 1.24 0 0 0-.21-1.12zM12.55 25.77a4.7 4.7 0 0 0-1.15 3.1v.82c0 .178.06.35.17.49h-1.23v-3.3c0-.24.072-.474.21-.67.551-.58 1.069-1.19 1.55-1.83 1.11-1.38 1.3-2.18 1.31-5.52.802-.142 1.616-.2 2.43-.17h6.38l3.25 1.94v4a.48.48 0 0 1-.21.33.89.89 0 0 1-.63.17l-4.34-1.94a7.14 7.14 0 0 0-6.31 1.3l-1.43 1.28zm4.71-.16a.57.57 0 0 0-.12.18 2.75 2.75 0 0 0 0 2.44l1 1.89v.07H17l-2.2-4.53.2-.16a5.57 5.57 0 0 1 3.49-1.14l-1.23 1.25zm7.09 4.58v-2.33a3 3 0 0 0-.35-1.4h.09a2.25 2.25 0 0 0 1.38 0v3c-.003.26.044.518.14.76l-1.26-.03zm5.82-14.67-.17.37a1.16 1.16 0 0 1-.91.34h-1.45a.75.75 0 0 0-.69.44l-1.06 2.42-2.47-1.44 2-4.13a.61.61 0 0 1 .58-.32h1.3c.09 0 .34.1.64.49a3.15 3.15 0 0 0 2.44 1.07h.08c-.15.42-.22.6-.29.76z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FiltersDogsIcon;
